import { ColorOptions } from './color-options';
import { GridCellContentAlignment } from '@grid/enums';
import { IAutoFocus, TextInputOptions } from '.';

export interface TextCellConfig extends IAutoFocus {
  options?: TextInputOptions;
  alignment?: GridCellContentAlignment;
  colorOptions?: ColorOptions;
}
